const IconSize = {
	WIDTH: 56,
	HEIGHT: 56,
};

export const initSectionObjects = ( mapNode, ymapsMap, ymapsObjectManager ) => {
	const component = mapNode.closest(`section.objects`);

	if ( component )
	{
		const customClusterIconLayout = ymaps.templateLayoutFactory.createClass(
			`<style>
				.map-pin-round::after
				{
					display: none !important;
					
					content: none !important;
				}
			</style>
			<div class="map-pin map-marker map-pin-round">
				<img src="/styles/images/map/02.svg" class="map-marker" alt="Несколько ЖК">
			</div>`
		);
		
		const clusterIcons = [
			{
				href: `/styles/images/map/02.svg`,
				size: [IconSize.WIDTH, IconSize.HEIGHT],
				offset: [-1 * IconSize.WIDTH / 2, -1 * IconSize.HEIGHT / 2]
			},
		];
		
		const clusterObjectManager = new ymaps.ObjectManager( {
			clusterize: true,
			clusterDisableClickZoom: false,
		} );
		
		clusterObjectManager.clusters.options.set( {
			clusterIcons: clusterIcons,
			clusterNumbers: [2, 3, 4],
			clusterIconContentLayout: customClusterIconLayout,
		} );
		
		const placemarks = [];
		const requiredIds = [`/complex/evropeyskiy-park/`, `/complex/geometriya/`];
		
		ymapsObjectManager.objects.each( ( geoObject ) => {
			const {properties} = geoObject;
			
			if ( properties && requiredIds.includes( properties.complexHref ) )
			{
				ymapsObjectManager.remove( geoObject );
				
				placemarks.push( geoObject );
			}
		} );
		
		clusterObjectManager.add( placemarks );
		ymapsMap.geoObjects.add( clusterObjectManager );
		
		const mapMarkerClickHandler = ( evt ) => {
			const marker = evt.get( `target` ).getById(evt.get( `objectId` ));
			
			if ( marker ) {
				const {complexHref} = marker.getData().properties;
				
				if ( complexHref )
				{
					location.href = complexHref;
				}
			}
		};
		
		clusterObjectManager.events.add( `click`, mapMarkerClickHandler );
		ymapsObjectManager.events.add( `click`, mapMarkerClickHandler );
		
		const copyrightLink = component.querySelector( `a[class*=copyright__logo]` );
		if ( copyrightLink )
		{
			copyrightLink.setAttribute( `aria-label`, `Переход к Яндекс картам` );
		}
	}
};
